import { apiSlice } from "../Slices/apiSlice";


export const privilegeService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllPrivileges: builder.query({
            query: () => "/privilege-management/managed-privilege",
            providesTags: ['priv']
        }),

        getPrivilegeById: builder.query({
            query: (id) => `/privilege-management/managed-privilege/${id}`,
            providesTags: ['priv']
        }),

        createPrivilege: builder.mutation({
            query: (details) => ({
                url: '/privilege-management/managed-privilege',
                method: 'POST',
                body: details
            }),
            invalidatesTags: ['priv']
        }),

        updatePrivilege: builder.mutation({
            query: (details) => ({
            url: `/privilege-management/managed-privilege`,
                method: "PUT",
                body: details,
            }),
            invalidatesTags: ["priv"],
        }),

        deletePrivilege: builder.mutation({
          query: (id) => ({
                url: `/privilege-management/managed-privilege/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["priv"],
        }),

    })
});

export const {
    useGetAllPrivilegesQuery,
    useGetPrivilegeByIdQuery,
    useCreatePrivilegeMutation,
    useUpdatePrivilegeMutation,
    useDeletePrivilegeMutation,
} = privilegeService;